enum GpsAccuracy {
	ROOFTOP = 'ROOFTOP',
	RANGE_INTERPOLATED = 'RANGE_INTERPOLATED',
	APPROXIMATE = 'APPROXIMATE',
	PRODUCER_SELECTED = 'PRODUCER SELECTED',
	UNDERWRITER_SELECTED = 'UNDERWRITER SELECTED',
}

export default GpsAccuracy;